import React from "react";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";

// Config
import { userTypes } from "../../config/values";
import styles from "../../config/styles";

// Components
import CardFooter from "./CardFooter";
import CardSummary from "./CardSummary";
import CardContent from "./CardContent";
import EvidenceScoreBar from "../EvidenceScoreBar";

// Utils
import { getEvidenceScore } from "../../utils/evidenceScore";

const useStyles = makeStyles({
  root: {
    border: styles.values.border,
    padding: 0
  }
});

const CaseCard = ({ data, isCollab }) => {
  const classes = useStyles();
  const caseId = data.id;

  const incidentDetailsCompleted =
    data.completedSections?.includes("IncidentDetails") ?? false;
  const evidenceStored = data.numberOfMediaItems || 0;
  const score = getEvidenceScore(incidentDetailsCompleted, evidenceStored);

  return (
    <Card elevation={0} className={classes.root}>
      <CardContent data={data} isCollab={isCollab} />
      {data.isDraft && !isCollab && (
        <EvidenceScoreBar score={score} isIntel={data.isIntel} />
      )}
      <CardSummary
        status={data.submissionStatus}
        incidentDate={data.incidentDateTime}
        mediaItems={data.numberOfMediaItems}
        patient={data.patientName}
        incidentTypeId={data.incidentTypeId}
        users={data.contributors}
        location={data.incidentLocation}
        isIntel={data.isIntel}
      />
      <CardFooter
        caseId={caseId}
        showMedicalRecords={data.capacity !== userTypes.Witness}
        disabled={data.isRestrictedForCurrentUser}
      />
    </Card>
  );
};

CaseCard.propTypes = {
  data: PropTypes.shape({
    capacity: PropTypes.string,
    completedSections: PropTypes.arrayOf(PropTypes.string),
    contributors: PropTypes.arrayOf(PropTypes.shape({})),
    incidentLocation: PropTypes.shape({}),
    id: PropTypes.string,
    incidentDateTime: PropTypes.string,
    isIntel: PropTypes.bool,
    isRestrictedForCurrentUser: PropTypes.bool,
    isLocked: PropTypes.bool,
    isDraft: PropTypes.bool,
    isOwnedByUser: PropTypes.bool,
    numberOfMediaItems: PropTypes.number,
    patientName: PropTypes.string,
    submissionStatus: PropTypes.string,
    userCapacity: PropTypes.string,
    incidentTypeId: PropTypes.string
  }).isRequired,
  isCollab: PropTypes.bool
};

CaseCard.defaultProps = {
  isCollab: false
};

export default React.memo(CaseCard);
